/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Property_OwnerInputs */

const en_explorer_info_property_owner = /** @type {(inputs: Explorer_Info_Property_OwnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Owner`)
};

const fr_explorer_info_property_owner = /** @type {(inputs: Explorer_Info_Property_OwnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proprietaire`)
};

const de_explorer_info_property_owner = /** @type {(inputs: Explorer_Info_Property_OwnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eigentümer`)
};

const it_explorer_info_property_owner = /** @type {(inputs: Explorer_Info_Property_OwnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proprietario`)
};

const ru_explorer_info_property_owner = /** @type {(inputs: Explorer_Info_Property_OwnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Владелец`)
};

const es_explorer_info_property_owner = /** @type {(inputs: Explorer_Info_Property_OwnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dueño`)
};

const zh_cn2_explorer_info_property_owner = /** @type {(inputs: Explorer_Info_Property_OwnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`所有者`)
};

const ja_explorer_info_property_owner = /** @type {(inputs: Explorer_Info_Property_OwnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`所有者`)
};

const hi_explorer_info_property_owner = /** @type {(inputs: Explorer_Info_Property_OwnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मालिक`)
};

const pt_pt2_explorer_info_property_owner = /** @type {(inputs: Explorer_Info_Property_OwnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proprietário`)
};

/**
* | output |
* | --- |
* | "Owner" |
*
* @param {Explorer_Info_Property_OwnerInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_property_owner = /** @type {((inputs?: Explorer_Info_Property_OwnerInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Property_OwnerInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_info_property_owner(inputs)
	if (locale === "de") return de_explorer_info_property_owner(inputs)
	if (locale === "it") return it_explorer_info_property_owner(inputs)
	if (locale === "ru") return ru_explorer_info_property_owner(inputs)
	if (locale === "es") return es_explorer_info_property_owner(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_info_property_owner(inputs)
	if (locale === "ja") return ja_explorer_info_property_owner(inputs)
	if (locale === "hi") return hi_explorer_info_property_owner(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_info_property_owner(inputs)
	return en_explorer_info_property_owner(inputs)
});